<div class="full-height">
    <div class="errorPage">
        <div class="left-area">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                version="1.1"
                x="0px"
                y="0px"
                width="100%"
                height="100%"
                viewBox="0 0 500 500"
                style="enable-background: new 0 0 500 500"
                xml:space="preserve">
                <style type="text/css">
                    .st0 {
                        fill: url(#SVGID_1_);
                    }
                    .st1 {
                        enable-background: new;
                    }
                    .st2 {
                        fill: #ffc64d;
                    }
                    .st3 {
                        fill: url(#SVGID_2_);
                    }
                    .st4 {
                        fill: url(#SVGID_3_);
                    }
                    .st5 {
                        fill: url(#SVGID_4_);
                    }
                    .st6 {
                        fill: url(#SVGID_5_);
                    }
                    .st7 {
                        fill: url(#SVGID_6_);
                    }
                    .st8 {
                        fill: url(#SVGID_7_);
                    }
                    .st9 {
                        fill: url(#SVGID_8_);
                    }
                    .st10 {
                        fill: #b181fc;
                    }
                    .st11 {
                        fill: url(#SVGID_9_);
                    }
                    .st12 {
                        fill: url(#SVGID_10_);
                    }
                    .st13 {
                        fill: url(#SVGID_11_);
                    }
                    .st14 {
                        fill: none;
                        stroke: #ffffff;
                        stroke-width: 2.066;
                        stroke-linecap: round;
                        stroke-miterlimit: 10;
                    }
                    .st15 {
                        clip-path: url(#SVGID_13_);
                        fill: none;
                        stroke: url(#SVGID_14_);
                        stroke-width: 0.9511;
                        stroke-miterlimit: 10;
                    }
                    .st16 {
                        fill: url(#SVGID_15_);
                    }
                    .st17 {
                        fill: url(#SVGID_16_);
                    }
                    .st18 {
                        fill: url(#SVGID_17_);
                    }
                    .st19 {
                        fill: url(#SVGID_18_);
                    }
                    .st20 {
                        opacity: 0.5;
                        fill: url(#SVGID_19_);
                    }
                    .st21 {
                        fill: url(#SVGID_20_);
                    }
                    .st22 {
                        fill: url(#SVGID_21_);
                    }
                    .st23 {
                        fill: url(#SVGID_22_);
                    }
                    .st24 {
                        fill: #240e4f;
                    }
                </style>
                <g id="Layer_3">
                    <linearGradient
                        id="SVGID_1_"
                        gradientUnits="userSpaceOnUse"
                        x1="250"
                        y1="11.6383"
                        x2="250"
                        y2="415.2156">
                        <stop offset="0" style="stop-color: #82a4f3; stop-opacity: 0.24" />
                        <stop offset="0.1714" style="stop-color: #a0b6ea; stop-opacity: 0.1989" />
                        <stop offset="0.3592" style="stop-color: #b9c5e3; stop-opacity: 0.1538" />
                        <stop offset="0.5552" style="stop-color: #cbd0dd; stop-opacity: 0.1068" />
                        <stop offset="0.7624" style="stop-color: #d6d7da; stop-opacity: 0.057" />
                        <stop offset="1" style="stop-color: #d9d9d9; stop-opacity: 0" />
                    </linearGradient>
                    <circle class="st0" cx="250" cy="250" r="238.36" />
                </g>
                <g id="Layer_13">
                    <g>
                        <g class="st1">
                            <g>
                                <path
                                    class="st2"
                                    d="M233.77,259.35l21.09-2.93c-23.11,3.21-44.65,13.7-62.15,30.54c-3.46,3.33-7.65,5.27-11.98,5.87      l-21.09,2.93c4.33-0.6,8.52-2.55,11.98-5.87C189.12,273.05,210.66,262.56,233.77,259.35z" />
                            </g>
                            <g>
                                <path
                                    class="st2"
                                    d="M223.05,173.85c-37.9,5.27-73.22,22.51-101.87,50.2c-3.46,3.34-7.66,5.3-12.01,5.9l21.09-2.93      c4.34-0.6,8.55-2.56,12.01-5.9c28.65-27.68,63.97-44.93,101.87-50.2L223.05,173.85z" />
                            </g>
                            <g>
                                <path
                                    class="st2"
                                    d="M244.34,298.59l21.09-2.93c3.03-0.42,6.13-0.56,9.3-0.4l-21.09,2.93      C250.47,298.03,247.36,298.17,244.34,298.59z" />
                            </g>
                            <g>
                                <path
                                    class="st2"
                                    d="M227.13,212.18l21.09-2.93c9.58-1.33,19.35-1.76,29.22-1.25l-21.09,2.93      C246.48,210.42,236.71,210.85,227.13,212.18z" />
                            </g>
                            <g>
                                <path
                                    class="st2"
                                    d="M286.57,114.66c-2.43-0.37-4.86-0.68-7.28-0.96l-1.14,1.3L286.57,114.66z" />
                                <path
                                    class="st2"
                                    d="M216.39,126.69c3.29-0.46,6.59-0.83,9.91-1.14l0.2-0.26L216.39,126.69z" />
                            </g>
                            <g>
                                <linearGradient
                                    id="SVGID_2_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="18.5443"
                                    y1="352.8328"
                                    x2="121.9761"
                                    y2="352.8328"
                                    gradientTransform="matrix(1 0 0 1 181.6741 0)">
                                    <stop offset="0.1119" style="stop-color: #ffee6b" />
                                    <stop offset="1" style="stop-color: #ffd54d" />
                                </linearGradient>
                                <path
                                    class="st3"
                                    d="M253.64,298.19c28.54,1.48,50.93,27.14,49.99,57.32s-24.85,53.45-53.39,51.97      c-28.54-1.48-50.93-27.14-49.99-57.32C201.19,319.99,225.09,296.71,253.64,298.19z" />
                            </g>
                            <g>
                                <path
                                    class="st2"
                                    d="M280.62,404.15l-21.09,2.93c24.26-3.37,43.26-24.74,44.09-51.57c0.94-30.18-21.44-55.84-49.99-57.32      l21.09-2.93c28.54,1.48,50.93,27.14,49.99,57.32C323.87,379.41,304.88,400.78,280.62,404.15z" />
                            </g>
                            <g>
                                <path
                                    class="st2"
                                    d="M377.71,304.21l-21.09,2.93c4.33-0.6,8.52-2.55,11.99-5.88c9.1-8.76,9.66-23.8,1.22-33.58      c-29.61-34.34-69.92-54.5-113.47-56.75l21.09-2.93c43.56,2.25,83.86,22.41,113.47,56.75c8.44,9.78,7.88,24.82-1.22,33.58      C386.23,301.66,382.04,303.61,377.71,304.21z" />
                            </g>
                            <g>
                                <linearGradient
                                    id="SVGID_3_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="-47.8155"
                                    y1="259.0341"
                                    x2="194.1391"
                                    y2="259.0341"
                                    gradientTransform="matrix(1 0 0 1 181.6741 0)">
                                    <stop offset="0.1119" style="stop-color: #ffee6b" />
                                    <stop offset="1" style="stop-color: #ffd54d" />
                                </linearGradient>
                                <path
                                    class="st4"
                                    d="M256.35,210.93c43.56,2.25,83.86,22.41,113.47,56.75c8.44,9.78,7.88,24.82-1.22,33.58      c-4.53,4.35-10.31,6.35-16.02,6.05c-5.79-0.3-11.51-2.96-15.76-7.88c-21.38-24.81-50.49-39.36-81.95-40.99      c-30.95-1.6-60.52,9.56-83.26,31.44c-4.52,4.35-10.31,6.34-16.01,6.05c-5.79-0.3-11.51-2.95-15.76-7.88      c-8.44-9.78-7.88-24.82,1.22-33.6C172.55,224.18,213.49,208.72,256.35,210.93z" />
                            </g>
                            <g>
                                <path
                                    class="st2"
                                    d="M442.92,212.74c-38.1-53.82-93.63-88.65-156.35-98.08l-8.42,0.34l-2.1,2.41      c58.3,11.62,109.69,45.47,145.6,96.19c7.46,10.54,5.47,25.46-4.43,33.31c-3.76,2.99-8.13,4.53-12.51,4.7l21.27-0.86      c4.38-0.18,8.75-1.71,12.51-4.7C448.4,238.2,450.38,223.28,442.92,212.74z" />
                            </g>
                            <g>
                                <linearGradient
                                    id="SVGID_4_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="-98.2831"
                                    y1="177.8542"
                                    x2="67.8626"
                                    y2="177.8542"
                                    gradientTransform="matrix(1 0 0 1 181.6741 0)">
                                    <stop offset="0.1119" style="stop-color: #ffee6b" />
                                    <stop offset="1" style="stop-color: #ffd54d" />
                                </linearGradient>
                                <path
                                    class="st5"
                                    d="M230.47,152.1l10.88-7.91l-21.75-9.75l6.7-8.88c-50.55,4.73-97.86,26.54-135.72,63.13      c-9.09,8.79-9.62,23.83-1.17,33.59c4.25,4.91,9.95,7.55,15.73,7.84c5.72,0.3,11.52-1.7,16.04-6.08      c33.71-32.57,76.65-50.7,122.18-51.86l6.18-8.07L230.47,152.1z" />

                                <linearGradient
                                    id="SVGID_5_"
                                    gradientUnits="userSpaceOnUse"
                                    x1="77.3044"
                                    y1="188.3838"
                                    x2="243.0087"
                                    y2="188.3838"
                                    gradientTransform="matrix(0.9952 0.0974 -0.0974 0.9952 206.1721 -17.8041)">
                                    <stop offset="0.1119" style="stop-color: #ffee6b" />
                                    <stop offset="1" style="stop-color: #ffd54d" />
                                </linearGradient>
                                <path
                                    class="st6"
                                    d="M421.65,213.6c-35.91-50.72-87.3-84.57-145.6-96.19l-6.12,7.02l20.05,11.86l-18.08,19.19l2.92,10.23      c44.34,10.62,83.31,37.31,110.95,76.35c3.75,5.3,9.17,8.48,14.89,9.34c5.67,0.85,11.63-0.57,16.56-4.48      C427.12,239.06,429.11,224.14,421.65,213.6z" />
                            </g>
                        </g>
                    </g>
                </g>
                <g id="Layer_14">
                    <g>
                        <linearGradient
                            id="SVGID_6_"
                            gradientUnits="userSpaceOnUse"
                            x1="198.3355"
                            y1="389.7629"
                            x2="166.6144"
                            y2="389.7629">
                            <stop offset="6.926126e-08" style="stop-color: #b181fc" />
                            <stop offset="0.2448" style="stop-color: #b486fc" />
                            <stop offset="0.5269" style="stop-color: #bc94fd" />
                            <stop offset="0.8264" style="stop-color: #c9abfe" />
                            <stop offset="0.9943" style="stop-color: #d2bbff" />
                        </linearGradient>
                        <path
                            class="st7"
                            d="M198.34,372.04c0,0-10.95,26.95-9.25,29.14c1.7,2.19,6.31,1.94,6.31,3.64s-1.46,2.67-4.61,2.67    c-3.16,0-21.13,0-23.31,0c-2.19,0,0.53-2.97,0.27-5.26c-0.28-2.4-0.37-22.66-0.37-22.66L198.34,372.04z" />
                        <linearGradient
                            id="SVGID_7_"
                            gradientUnits="userSpaceOnUse"
                            x1="109.4567"
                            y1="389.7629"
                            x2="131.9288"
                            y2="389.7629">
                            <stop offset="6.926126e-08" style="stop-color: #b181fc" />
                            <stop offset="0.2448" style="stop-color: #b486fc" />
                            <stop offset="0.5269" style="stop-color: #bc94fd" />
                            <stop offset="0.8264" style="stop-color: #c9abfe" />
                            <stop offset="0.9943" style="stop-color: #d2bbff" />
                        </linearGradient>
                        <path
                            class="st8"
                            d="M109.19,372.04c0,0-1.21,26.95-2.91,29.14c-1.7,2.19-6.31,1.94-6.31,3.64s1.46,2.67,4.61,2.67    c3.16,0,21.13,0,23.31,0s1.21-1.94,1.94-4.13s10.44-23.8,10.44-23.8L109.19,372.04z" />

                        <radialGradient
                            id="SVGID_8_"
                            cx="154.7311"
                            cy="306.1486"
                            r="82.3125"
                            fx="163.5798"
                            fy="343.1223"
                            gradientUnits="userSpaceOnUse">
                            <stop offset="6.926126e-08" style="stop-color: #ffffff" />
                            <stop offset="0.3033" style="stop-color: #fcfaff" />
                            <stop offset="0.6522" style="stop-color: #f3ecff" />
                            <stop offset="1" style="stop-color: #e5d7ff" />
                        </radialGradient>
                        <path
                            class="st9"
                            d="M229.68,306.15c5.98,37.7-9.56,88.07-75.33,88.07c-59.21,0-80.85-43.48-74.75-88.07    c6.48-47.35,36.31-88.07,74.75-88.07S222.06,258.15,229.68,306.15z" />
                        <path
                            class="st10"
                            d="M96.23,295.18c-0.94-0.96-1.45-2.23-1.43-3.57c0.11-10.74,11.17-66.08,62.51-66.08    c49.56,0,56.4,66.29,56.4,68.66c0,4.21-22.41,17.86-60.61,17.1C121.26,310.66,102.3,301.36,96.23,295.18z" />

                        <radialGradient
                            id="SVGID_9_"
                            cx="153.8955"
                            cy="270.0597"
                            r="59.7807"
                            fx="160.322"
                            fy="296.9124"
                            gradientUnits="userSpaceOnUse">
                            <stop offset="0" style="stop-color: #240e4f" />
                            <stop offset="0.1355" style="stop-color: #270f54" />
                            <stop offset="0.2919" style="stop-color: #2f1362" />
                            <stop offset="0.4585" style="stop-color: #3e1879" />
                            <stop offset="0.6323" style="stop-color: #522099" />
                            <stop offset="0.8118" style="stop-color: #6b2ac3" />
                            <stop offset="0.9936" style="stop-color: #8a37f5" />
                            <stop offset="1" style="stop-color: #8b37f7" />
                        </radialGradient>
                        <path
                            class="st11"
                            d="M100.02,295.38c-0.88-0.89-1.35-2.08-1.34-3.33c0.1-10.03,11.25-62.39,58.3-62.39    c45.23,0,52.08,61.78,52.13,64.14c0.08,3.93-20.28,17.35-55.96,16.64C123.41,309.84,105.69,301.15,100.02,295.38z" />

                        <radialGradient
                            id="SVGID_10_"
                            cx="150.1432"
                            cy="262.9333"
                            r="10.8003"
                            fx="151.3043"
                            fy="267.7847"
                            gradientTransform="matrix(0.99 0.141 -0.141 0.99 28.6396 -22.4919)"
                            gradientUnits="userSpaceOnUse">
                            <stop offset="6.926126e-08" style="stop-color: #ffffff" />
                            <stop offset="0.5258" style="stop-color: #fcfaff" />
                            <stop offset="1" style="stop-color: #f6f0ff" />
                        </radialGradient>
                        <path
                            class="st12"
                            d="M149.95,260.37c0.08,5.01-2.87,11.26-11.41,10.05c-7.69-1.1-9.7-7.14-8.08-12.82    c1.72-6.03,6.35-10.77,11.34-10.06S149.85,253.99,149.95,260.37z" />

                        <radialGradient
                            id="SVGID_11_"
                            cx="163.6115"
                            cy="249.862"
                            r="10.8003"
                            fx="164.7726"
                            fy="254.7134"
                            gradientTransform="matrix(0.9793 -0.2026 0.2026 0.9793 -33.0033 47.4495)"
                            gradientUnits="userSpaceOnUse">
                            <stop offset="6.926126e-08" style="stop-color: #ffffff" />
                            <stop offset="0.5258" style="stop-color: #fcfaff" />
                            <stop offset="1" style="stop-color: #f6f0ff" />
                        </radialGradient>
                        <path
                            class="st13"
                            d="M187.47,256.99c1.77,4.68,1.11,11.57-7.34,13.32c-7.61,1.57-11.54-3.44-11.95-9.33    c-0.43-6.26,2.32-12.28,7.26-13.3C180.39,246.66,185.21,251.03,187.47,256.99z" />
                        <line class="st14" x1="150.69" y1="289.38" x2="169.41" y2="289.38" />
                        <g>
                            <defs>
                                <path
                                    id="SVGID_12_"
                                    d="M229.68,306.15c5.98,37.7-9.56,88.07-75.33,88.07c-59.21,0-80.85-43.48-74.75-88.07      c6.48-47.35,36.31-88.07,74.75-88.07S222.06,258.15,229.68,306.15z" />
                            </defs>
                            <clipPath id="SVGID_13_">
                                <use xlink:href="#SVGID_12_" style="overflow: visible" />
                            </clipPath>
                            <radialGradient
                                id="SVGID_14_"
                                cx="154.3991"
                                cy="337.7041"
                                r="60.9705"
                                gradientUnits="userSpaceOnUse">
                                <stop offset="0" style="stop-color: #210847" />
                                <stop offset="0.1355" style="stop-color: #240b4c" />
                                <stop offset="0.2919" style="stop-color: #2e125a" />
                                <stop offset="0.4585" style="stop-color: #3f1e71" />
                                <stop offset="0.6323" style="stop-color: #563091" />
                                <stop offset="0.8118" style="stop-color: #7446bb" />
                                <stop offset="0.9936" style="stop-color: #9861ed" />
                                <stop offset="1" style="stop-color: #9962ef" />
                            </radialGradient>
                            <path
                                class="st15"
                                d="M79.6,299.59l20.01,17.8c0.62,0.61,0.94,1.46,0.89,2.32c-0.55,8.99-1.21,59.84,54.23,59.84     c55,0,54.16-51.64,53.5-61.51c-0.07-1.05,0.35-2.06,1.13-2.76l19.82-19.58" />
                        </g>
                        <linearGradient
                            id="SVGID_15_"
                            gradientUnits="userSpaceOnUse"
                            x1="130.4179"
                            y1="326.6645"
                            x2="170.9587"
                            y2="358.3385">
                            <stop offset="6.926126e-08" style="stop-color: #240e4f" />
                            <stop offset="0.1355" style="stop-color: #270f54" />
                            <stop offset="0.2919" style="stop-color: #2f1362" />
                            <stop offset="0.4585" style="stop-color: #3e1879" />
                            <stop offset="0.6323" style="stop-color: #522099" />
                            <stop offset="0.8118" style="stop-color: #6b2ac3" />
                            <stop offset="0.9936" style="stop-color: #8a37f5" />
                            <stop offset="1" style="stop-color: #8b37f7" />
                        </linearGradient>
                        <ellipse class="st16" cx="150.69" cy="342.5" rx="26.89" ry="23.68" />
                        <radialGradient
                            id="SVGID_16_"
                            cx="151.3142"
                            cy="341.7231"
                            r="22.9084"
                            gradientUnits="userSpaceOnUse">
                            <stop offset="0" style="stop-color: #eae3ff" />
                            <stop offset="0.2" style="stop-color: #e7deff" />
                            <stop offset="0.4305" style="stop-color: #dfd0ff" />
                            <stop offset="0.6762" style="stop-color: #d2b9ff" />
                            <stop offset="0.9308" style="stop-color: #c099ff" />
                            <stop offset="1" style="stop-color: #ba8fff" />
                        </radialGradient>
                        <ellipse class="st17" cx="151.31" cy="341.72" rx="24.32" ry="21.41" />
                        <linearGradient
                            id="SVGID_17_"
                            gradientUnits="userSpaceOnUse"
                            x1="139.8514"
                            y1="339.8072"
                            x2="166.944"
                            y2="344.0755">
                            <stop offset="4.102398e-07" style="stop-color: #212aa3" />
                            <stop offset="0.0367" style="stop-color: #3a2ab2" />
                            <stop offset="0.0785" style="stop-color: #4f29be" />
                            <stop offset="0.1254" style="stop-color: #5e29c7" />
                            <stop offset="0.1812" style="stop-color: #6629cc" />
                            <stop offset="0.2689" style="stop-color: #6929ce" />
                            <stop offset="0.3765" style="stop-color: #8f38b9" />
                            <stop offset="0.5303" style="stop-color: #cc5097" />
                            <stop offset="0.678" style="stop-color: #c7536b" />
                            <stop offset="0.7944" style="stop-color: #c4554d" />
                            <stop offset="1" style="stop-color: #bc8535" />
                        </linearGradient>
                        <path
                            class="st18"
                            d="M145.91,333.69c0.39,0.11,0.77,0.12,1.13,0.06c0.46-0.08,0.92,0.08,1.25,0.41l0.72,0.72    c0.35,0.35,0.5,0.85,0.39,1.33c-0.1,0.44-0.08,0.92,0.1,1.42c0.31,0.87,1.07,1.55,1.98,1.72c1.69,0.31,3.16-0.97,3.16-2.6    c0-0.2-0.02-0.39-0.07-0.58c-0.11-0.48,0.05-0.97,0.39-1.32l0.71-0.71c0.34-0.34,0.81-0.49,1.28-0.4    c0.42,0.08,0.88,0.06,1.35-0.11c0.9-0.32,1.58-1.12,1.72-2.06c0.29-1.83-1.3-3.38-3.14-3.02c-0.95,0.18-1.75,0.92-2.01,1.85    c-0.14,0.51-0.13,1-0.01,1.44c0.14,0.5,0,1.04-0.37,1.42l-0.54,0.54c-0.35,0.35-0.86,0.52-1.33,0.39    c-0.2-0.05-0.42-0.08-0.64-0.08c-0.23,0-0.44,0.03-0.65,0.09c-0.48,0.13-0.99-0.04-1.34-0.39l-0.49-0.49    c-0.37-0.37-0.52-0.92-0.37-1.43c0.13-0.45,0.15-0.94,0.01-1.45c-0.25-0.94-1.04-1.68-1.99-1.87c-1.86-0.38-3.48,1.18-3.17,3.03    C144.16,332.58,144.93,333.42,145.91,333.69z M158.31,349.82c-0.48-0.17-0.93-0.19-1.35-0.11c-0.47,0.09-0.94-0.07-1.28-0.4    l-0.71-0.71c-0.35-0.35-0.51-0.84-0.39-1.32c0.04-0.18,0.07-0.38,0.07-0.58c0-1.63-1.47-2.91-3.16-2.6    c-0.91,0.17-1.67,0.85-1.98,1.72c-0.18,0.51-0.19,0.99-0.1,1.42c0.11,0.48-0.04,0.98-0.39,1.33l-0.72,0.72    c-0.33,0.33-0.79,0.49-1.25,0.41c-0.36-0.06-0.74-0.05-1.13,0.06c-0.98,0.26-1.75,1.1-1.91,2.11c-0.3,1.85,1.31,3.42,3.17,3.03    c0.95-0.2,1.74-0.93,1.99-1.87c0.14-0.51,0.12-1.01-0.01-1.45c-0.15-0.51-0.01-1.06,0.37-1.43l0.49-0.49    c0.35-0.35,0.86-0.52,1.34-0.39c0.21,0.06,0.43,0.09,0.65,0.09c0.22,0,0.43-0.03,0.64-0.08c0.48-0.12,0.98,0.04,1.33,0.39    l0.54,0.54c0.37,0.37,0.51,0.91,0.37,1.42c-0.12,0.44-0.14,0.93,0.01,1.44c0.26,0.94,1.06,1.67,2.01,1.85    c1.84,0.36,3.43-1.19,3.14-3.02C159.88,350.95,159.2,350.14,158.31,349.82z M144.03,346.69c-0.08-0.46,0.08-0.92,0.41-1.25    l0.72-0.72c0.35-0.35,0.85-0.5,1.33-0.39c0.44,0.1,0.92,0.08,1.42-0.1c0.87-0.31,1.55-1.07,1.72-1.98    c0.31-1.69-0.97-3.16-2.6-3.16c-0.2,0-0.39,0.02-0.58,0.07c-0.48,0.11-0.97-0.05-1.32-0.39l-0.71-0.71    c-0.34-0.34-0.49-0.81-0.4-1.28c0.08-0.42,0.06-0.88-0.11-1.35c-0.32-0.9-1.12-1.58-2.06-1.72c-1.83-0.29-3.38,1.3-3.02,3.14    c0.18,0.95,0.92,1.75,1.85,2.01c0.51,0.14,1,0.13,1.44,0.01c0.5-0.14,1.04,0,1.42,0.37l0.54,0.54c0.35,0.35,0.52,0.86,0.39,1.33    c-0.05,0.2-0.08,0.42-0.08,0.64c0,0.23,0.03,0.44,0.09,0.65c0.13,0.48-0.04,0.99-0.39,1.34l-0.49,0.49    c-0.37,0.37-0.92,0.52-1.43,0.37c-0.45-0.13-0.94-0.15-1.45-0.01c-0.94,0.25-1.68,1.04-1.87,1.99c-0.38,1.86,1.18,3.48,3.03,3.17    c1-0.16,1.84-0.93,2.11-1.91C144.08,347.43,144.09,347.05,144.03,346.69z M165.19,346.56c-0.2-0.95-0.93-1.74-1.87-1.99    c-0.51-0.14-1.01-0.12-1.45,0.01c-0.51,0.15-1.06,0.01-1.43-0.37l-0.49-0.49c-0.35-0.35-0.52-0.86-0.39-1.34    c0.06-0.21,0.09-0.43,0.09-0.65c0-0.22-0.03-0.43-0.08-0.64c-0.12-0.48,0.04-0.98,0.39-1.33l0.54-0.54    c0.37-0.37,0.91-0.51,1.42-0.37c0.44,0.12,0.93,0.14,1.44-0.01c0.94-0.26,1.67-1.06,1.85-2.01c0.36-1.84-1.19-3.43-3.02-3.14    c-0.94,0.15-1.74,0.83-2.06,1.72c-0.17,0.48-0.19,0.93-0.11,1.35c0.09,0.47-0.07,0.94-0.4,1.28l-0.71,0.71    c-0.35,0.35-0.84,0.51-1.32,0.39c-0.18-0.04-0.38-0.07-0.58-0.07c-1.63,0-2.91,1.47-2.6,3.16c0.17,0.91,0.85,1.67,1.72,1.98    c0.51,0.18,0.99,0.19,1.42,0.1c0.48-0.11,0.98,0.04,1.33,0.39l0.72,0.72c0.33,0.33,0.49,0.79,0.41,1.25    c-0.06,0.36-0.05,0.74,0.06,1.13c0.26,0.98,1.1,1.75,2.11,1.91C164,350.04,165.57,348.42,165.19,346.56z" />
                        <linearGradient
                            id="SVGID_18_"
                            gradientUnits="userSpaceOnUse"
                            x1="139.153"
                            y1="339.8072"
                            x2="166.2456"
                            y2="344.0755">
                            <stop offset="4.102398e-07" style="stop-color: #373ecc" />
                            <stop offset="0.0119" style="stop-color: #423dd1" />
                            <stop offset="0.0483" style="stop-color: #5c3bdf" />
                            <stop offset="0.0881" style="stop-color: #7139ea" />
                            <stop offset="0.1327" style="stop-color: #8038f1" />
                            <stop offset="0.1857" style="stop-color: #8837f6" />
                            <stop offset="0.2689" style="stop-color: #8b37f7" />
                            <stop offset="0.3633" style="stop-color: #b147e1" />
                            <stop offset="0.5303" style="stop-color: #fd66b5" />
                            <stop offset="0.6895" style="stop-color: #fb6e80" />
                            <stop offset="0.7944" style="stop-color: #fa7262" />
                            <stop offset="1" style="stop-color: #ffbb4d" />
                        </linearGradient>
                        <path
                            class="st19"
                            d="M145.21,333.69c0.39,0.11,0.77,0.12,1.13,0.06c0.46-0.08,0.92,0.08,1.25,0.41l0.72,0.72    c0.35,0.35,0.5,0.85,0.39,1.33c-0.1,0.44-0.08,0.92,0.1,1.42c0.31,0.87,1.07,1.55,1.98,1.72c1.69,0.31,3.16-0.97,3.16-2.6    c0-0.2-0.02-0.39-0.07-0.58c-0.11-0.48,0.05-0.97,0.39-1.32l0.71-0.71c0.34-0.34,0.81-0.49,1.28-0.4    c0.42,0.08,0.88,0.06,1.35-0.11c0.9-0.32,1.58-1.12,1.72-2.06c0.29-1.83-1.3-3.38-3.14-3.02c-0.95,0.18-1.75,0.92-2.01,1.85    c-0.14,0.51-0.13,1-0.01,1.44c0.14,0.5,0,1.04-0.37,1.42l-0.54,0.54c-0.35,0.35-0.86,0.52-1.33,0.39    c-0.2-0.05-0.42-0.08-0.64-0.08c-0.23,0-0.44,0.03-0.65,0.09c-0.48,0.13-0.99-0.04-1.34-0.39l-0.49-0.49    c-0.37-0.37-0.52-0.92-0.37-1.43c0.13-0.45,0.15-0.94,0.01-1.45c-0.25-0.94-1.04-1.68-1.99-1.87c-1.86-0.38-3.48,1.18-3.17,3.03    C143.46,332.58,144.24,333.42,145.21,333.69z M157.61,349.82c-0.48-0.17-0.93-0.19-1.35-0.11c-0.47,0.09-0.94-0.07-1.28-0.4    l-0.71-0.71c-0.35-0.35-0.51-0.84-0.39-1.32c0.04-0.18,0.07-0.38,0.07-0.58c0-1.63-1.47-2.91-3.16-2.6    c-0.91,0.17-1.67,0.85-1.98,1.72c-0.18,0.51-0.19,0.99-0.1,1.42c0.11,0.48-0.04,0.98-0.39,1.33l-0.72,0.72    c-0.33,0.33-0.79,0.49-1.25,0.41c-0.36-0.06-0.74-0.05-1.13,0.06c-0.98,0.26-1.75,1.1-1.91,2.11c-0.3,1.85,1.31,3.42,3.17,3.03    c0.95-0.2,1.74-0.93,1.99-1.87c0.14-0.51,0.12-1.01-0.01-1.45c-0.15-0.51-0.01-1.06,0.37-1.43l0.49-0.49    c0.35-0.35,0.86-0.52,1.34-0.39c0.21,0.06,0.43,0.09,0.65,0.09c0.22,0,0.43-0.03,0.64-0.08c0.48-0.12,0.98,0.04,1.33,0.39    l0.54,0.54c0.37,0.37,0.51,0.91,0.37,1.42c-0.12,0.44-0.14,0.93,0.01,1.44c0.26,0.94,1.06,1.67,2.01,1.85    c1.84,0.36,3.43-1.19,3.14-3.02C159.18,350.95,158.5,350.14,157.61,349.82z M143.33,346.69c-0.08-0.46,0.08-0.92,0.41-1.25    l0.72-0.72c0.35-0.35,0.85-0.5,1.33-0.39c0.44,0.1,0.92,0.08,1.42-0.1c0.87-0.31,1.55-1.07,1.72-1.98    c0.31-1.69-0.97-3.16-2.6-3.16c-0.2,0-0.39,0.02-0.58,0.07c-0.48,0.11-0.97-0.05-1.32-0.39l-0.71-0.71    c-0.34-0.34-0.49-0.81-0.4-1.28c0.08-0.42,0.06-0.88-0.11-1.35c-0.32-0.9-1.12-1.58-2.06-1.72c-1.83-0.29-3.38,1.3-3.02,3.14    c0.18,0.95,0.92,1.75,1.85,2.01c0.51,0.14,1,0.13,1.44,0.01c0.5-0.14,1.04,0,1.42,0.37l0.54,0.54c0.35,0.35,0.52,0.86,0.39,1.33    c-0.05,0.2-0.08,0.42-0.08,0.64c0,0.23,0.03,0.44,0.09,0.65c0.13,0.48-0.04,0.99-0.39,1.34l-0.49,0.49    c-0.37,0.37-0.92,0.52-1.43,0.37c-0.45-0.13-0.94-0.15-1.45-0.01c-0.94,0.25-1.68,1.04-1.87,1.99c-0.38,1.86,1.18,3.48,3.03,3.17    c1-0.16,1.84-0.93,2.11-1.91C143.38,347.43,143.39,347.05,143.33,346.69z M164.49,346.56c-0.2-0.95-0.93-1.74-1.87-1.99    c-0.51-0.14-1.01-0.12-1.45,0.01c-0.51,0.15-1.06,0.01-1.43-0.37l-0.49-0.49c-0.35-0.35-0.52-0.86-0.39-1.34    c0.06-0.21,0.09-0.43,0.09-0.65c0-0.22-0.03-0.43-0.08-0.64c-0.12-0.48,0.04-0.98,0.39-1.33l0.54-0.54    c0.37-0.37,0.91-0.51,1.42-0.37c0.44,0.12,0.93,0.14,1.44-0.01c0.94-0.26,1.67-1.06,1.85-2.01c0.36-1.84-1.19-3.43-3.02-3.14    c-0.94,0.15-1.74,0.83-2.06,1.72c-0.17,0.48-0.19,0.93-0.11,1.35c0.09,0.47-0.07,0.94-0.4,1.28l-0.71,0.71    c-0.35,0.35-0.84,0.51-1.32,0.39c-0.18-0.04-0.38-0.07-0.58-0.07c-1.63,0-2.91,1.47-2.6,3.16c0.17,0.91,0.85,1.67,1.72,1.98    c0.51,0.18,0.99,0.19,1.42,0.1c0.48-0.11,0.98,0.04,1.33,0.39l0.72,0.72c0.33,0.33,0.49,0.79,0.41,1.25    c-0.06,0.36-0.05,0.74,0.06,1.13c0.26,0.98,1.1,1.75,2.11,1.91C163.31,350.04,164.87,348.42,164.49,346.56z" />
                        <linearGradient
                            id="SVGID_19_"
                            gradientUnits="userSpaceOnUse"
                            x1="217.7735"
                            y1="286.694"
                            x2="249.5162"
                            y2="339.5228">
                            <stop offset="0" style="stop-color: #a36b08" />
                            <stop offset="0.189" style="stop-color: #a8700c" />
                            <stop offset="0.4068" style="stop-color: #b67e16" />
                            <stop offset="0.6389" style="stop-color: #cd9427" />
                            <stop offset="0.8795" style="stop-color: #edb43f" />
                            <stop offset="0.9943" style="stop-color: #ffc64d" />
                        </linearGradient>
                        <path
                            class="st20"
                            d="M231.35,305.04c3.71,16.47,8.81,2.19,4.99,8.03c-2.89,4.41-10.99,5.05-16.41,7.63    c-8.61,4.09-16.88,15.2-10.13,25.68c6.04,9.38,19.4,13.14,26.1-5.25c2.58-7.09-10.4-4.92-5.68-5.15c11.25-0.54,17.73-1,24.45-3.76    c7.94-3.25,18.72-10.39,18.4-23.49c-0.18-7.53-8.32-14.24-18.71-20.04c-7.98-4.45-19.89-8.54-29.17-6.45    C225.19,282.24,229.83,298.29,231.35,305.04z" />

                        <linearGradient
                            id="SVGID_20_"
                            gradientUnits="userSpaceOnUse"
                            x1="196.3549"
                            y1="16.7041"
                            x2="255.8302"
                            y2="16.7041"
                            gradientTransform="matrix(-0.5661 -0.8244 0.8244 -0.5661 344.5046 505.7442)">
                            <stop offset="0" style="stop-color: #b181fc" />
                            <stop offset="0.2448" style="stop-color: #b486fc" />
                            <stop offset="0.5269" style="stop-color: #bc94fd" />
                            <stop offset="0.8264" style="stop-color: #c9abfe" />
                            <stop offset="0.9943" style="stop-color: #d2bbff" />
                        </linearGradient>
                        <path
                            class="st21"
                            d="M228.92,301.8c3.71,16.47,8.81,2.19,4.99,8.03c-2.89,4.41-10.99,5.05-16.41,7.63    c-8.61,4.09-16.88,15.2-10.13,25.68c6.04,9.38,19.4,13.14,26.1-5.25c2.58-7.09-10.4-4.92-5.68-5.15c11.25-0.54,17.73-1,24.45-3.76    c7.94-3.25,18.72-10.39,18.4-23.49c-0.18-7.53-8.32-14.24-18.71-20.04c-7.98-4.45-19.89-8.54-29.17-6.45    C222.77,279,227.4,295.06,228.92,301.8z" />
                        <linearGradient
                            id="SVGID_21_"
                            gradientUnits="userSpaceOnUse"
                            x1="59.683"
                            y1="329.3599"
                            x2="80.8781"
                            y2="329.3599">
                            <stop offset="6.926126e-08" style="stop-color: #b181fc" />
                            <stop offset="0.2448" style="stop-color: #b486fc" />
                            <stop offset="0.5269" style="stop-color: #bc94fd" />
                            <stop offset="0.8264" style="stop-color: #c9abfe" />
                            <stop offset="0.9943" style="stop-color: #d2bbff" />
                        </linearGradient>
                        <path
                            class="st22"
                            d="M80.88,298.9c0,0-0.22,0.36-0.6,1.02c-2.98,5.11-21.73,21.74-20.54,39.56    c1.38,20.57,17.78,20.34,17.78,20.34S80.01,303.24,80.88,298.9z" />

                        <linearGradient
                            id="SVGID_22_"
                            gradientUnits="userSpaceOnUse"
                            x1="86.8642"
                            y1="340.2474"
                            x2="177.4484"
                            y2="340.2474"
                            gradientTransform="matrix(0.9742 0.2257 -0.2257 0.9742 63.0955 -36.1293)">
                            <stop offset="6.926126e-08" style="stop-color: #b181fc" />
                            <stop offset="0.2448" style="stop-color: #b486fc" />
                            <stop offset="0.5269" style="stop-color: #bc94fd" />
                            <stop offset="0.8264" style="stop-color: #c9abfe" />
                            <stop offset="0.9943" style="stop-color: #d2bbff" />
                        </linearGradient>
                        <path
                            class="st23"
                            d="M72.6,329.81c4.47-2.96,10.84-5.46,20.44-6.48c9.6-1.02,28.52-1.08,31.46-5.23    c2.94-4.14,2.76-14.36,7.8-16.58c5.04-2.22,9.96-1.18,11.62-3.01c1.66-1.83,8.09-9.82,11.29-7.39s3.65,2.82,2.64,5.42    c-1.01,2.59-4.3,3.99-3.52,7.05s6.96,6.74,7.64,10.96c1.49,9.21-0.11,13.45-10.61,18.24c-10.02,4.57-11.01,1.13-14.8,4.07    c-3.79,2.93-23.98,17.49-35,20.52c-11.03,3.03-19.38,5.18-29.05,0.98C64.2,354.76,59.94,338.18,72.6,329.81z" />
                        <ellipse class="st24" cx="141.83" cy="252.75" rx="4.21" ry="5.22" />
                        <ellipse class="st24" cx="178.29" cy="252.75" rx="4.21" ry="5.22" />
                    </g>
                </g>
            </svg>
        </div>
        <div class="right-area">
            <h1>{{ 'OFFLINE.OOPS' | translate }}!</h1>
            <h2>
                <span> {{ 'OFFLINE.NO_INTERNET_AVAILABLE' | translate | titlecase }}</span>
            </h2>
            <div class="custom-message">
                <p>{{ 'OFFLINE.CHECK_INTERNET_CONNECTION' | translate }}</p>
            </div>
        </div>
    </div>
</div>
